import React, { Component } from "react";
import ChatSessionService from "services/chat-session.service";
import AuthService from "services/auth.service";
import { TwilioConversation } from "./TwilioConversation";
import ChatSessionDetails from "./ChatSessionDetails";
import Prescription from "./Prescription";
import MedicalCertificate from "./MedicalCertificate";
import ExtraCharge from "./ExtraCharge";
import CovidRiskChecker from "./CovidRiskChecker";
import ChallengeEligibilityChecker from "./ChallengeEligibilityChecker";
import Spinner from "react-bootstrap/Spinner";
import IconChatBubble from "assets/icons/Chat-bubble-icon.svg";
import { Col } from "react-bootstrap";
import { connect } from "react-redux";
import { removeUnreads } from "app/teleconsultSlice";

class ChatSession extends Component {
  
  constructor(props) {
    super(props);

    this.initialStates = {
      chat_loading: false,
      chat: {},
      messages: [],
      messages_loading: false,
      is_cancelled: false,
      conversationMsgs: null,
    };
    this.state = this.initialStates;

    this.updateReadStatus = this.updateReadStatus.bind(this);
  }

  loadMessagesFor = (thisConversation) => {
    thisConversation
      .getMessages(100)
      .then((messagePaginator) => {
        this.setState({
          messages: messagePaginator.items,
          messages_loading: false,
          conversationMsgs: messagePaginator,
        });
      })
      .catch((err) => {
        console.error("Couldn't fetch messages IMPLEMENT RETRY", err);
        this.setState({ messages_loading: false });
      });
  };

  componentDidUpdate(prevProps) {
    if (this.props.chat && this.props.chat !== prevProps.chat) {
      // switch all loading to status true
      if (
        this.props.chat.video_session &&
        this.props.chat.video_session.is_cancelled &&
        !this.props.chat.is_nop
      ) {
        this.setState({
          is_cancelled: true,
        });
      } else {
        this.setState(
          {
            chat_loading: true,
            messages_loading: true,
            is_cancelled: false,
          },
          () => {
            this.getChatSession();
          }
        );
      }
    }

    if (this.props.doReset && this.props.doReset !== prevProps.doReset) {
      this.setState(this.initialStates);
    }

    if (
      this.props.selectedConversation &&
      this.props.selectedConversation !== prevProps.selectedConversation
    ) {
      // get messages
      this.loadMessagesFor(this.props.selectedConversation);

      let newConversation = this.props.selectedConversation;
      newConversation.on("messageAdded", (m) =>
        this.messageAdded(m, newConversation)
      );
    }
  }

  messageAdded = (message, targetConversation) => {
    this.setState((prevState, props) => ({
      messages: [...prevState.messages, message],
    }));
  };

  getChatSession() {
    ChatSessionService.show(this.props.chat.id)
      .then(
        (data) => {
          let newData = {
            hasStarted: this.props.chat.hasStarted,
            isInBuffer: this.props.chat.isInBuffer,
          };

          this.setState(
            {
              chat: { ...data.chat_session, ...newData },
            },
            () => {
              let params = {
                read_by_doctor: 1,
              };
              this.updateReadStatus(params);
            }
          );
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        }
      )
      .then(() => {
        this.setState({ chat_loading: false });
      });
  }

  updateReadStatus(params) {
    ChatSessionService.updateReadStatus(
      this.props.chat.twilio_sid,
      params
    ).then(
      (data) => {
        // update unread batch number
        this.props.removeUnreads(this.props.chat.twilio_sid);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  }

  conversationView() {
    switch (this.props.conversationStatus) {
      case "success":
        return (
          <TwilioConversation
            chat={this.state.chat}
            messages={this.state.messages}
            conversation={this.props.selectedConversation}
            updateReadStatus={this.updateReadStatus}
            conversationMsgs={this.state.conversationMsgs}
          />
        );
      case "error":
      case "warning":
        return <div className="loader">Fail to connect to chatroom</div>;
      default:
        return (
          <div className="loader">
            <Spinner animation="border" className="spinner" />
          </div>
        );
    }
  }

  render() {

    const currentUser = AuthService.getCurrentUser();
    
    return (
      <div className="chat-session-content">
        {(() => {
          if (this.state.chat_loading || this.state.messages_loading) {
            return (
              <div className="loader">
                <Spinner animation="border" className="spinner" />
              </div>
            );
          } else if (this.state.is_cancelled) {
            return <div className="loader">Session Has Been Cancelled</div>;
          } else {
            return Object.keys(this.state.chat).length === 0 ? (
              <div className="no-chat-selected">
                <img src={IconChatBubble} alt="chat-bubble-img" />
                <div className="no-chat-text">Welcome!</div>
                <p className="no-chat-subtext">
                  To view your patient’s medical notes, select the patient's
                  chat in 'Ongoing' or 'History' tabs.
                </p>
              </div>
            ) : (
              <>
                <div className="chat-session d-flex">
                  <Col md={8} className="p-0">
                    {this.conversationView()}
                  </Col>
                  <Col md={4} className="p-0">
                    <ChatSessionDetails chat={this.state.chat} />
                  </Col>
                </div>
                {currentUser?.is_bookdoc_nutritionist && (
                  <ChallengeEligibilityChecker chat={this.state.chat} />
                )}
                {this.state.chat.covid?.enabled &&
                  this.state.chat.hasStarted && (
                    <CovidRiskChecker chat={this.state.chat} />
                  )}
                {this.state.chat.e_prescription.enabled &&
                  this.state.chat.hasStarted && (
                    <Prescription chat={this.state.chat} />
                  )}
                {this.state.chat.e_mc?.enabled &&
                  this.state.chat.hasStarted && (
                    <MedicalCertificate chat={this.state.chat} />
                  )}
                {this.state.chat.extra_charge.enabled &&
                  this.state.chat.hasStarted && (
                    <ExtraCharge chat={this.state.chat} />
                  )}
              </>
            );
          }
        })()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  removeUnreads,
};

export default connect(null, mapDispatchToProps)(ChatSession);
